// hooks/useExternalLogin.ts
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { ExternalAccountLogin } from '../services/externalAccount.service';
import { ApiResultModel } from '../models/common.model';
import { ICheckOtpResponse } from '../models/account.model';
import { setJwtToken } from '../services/auth.service';

export const useExternalLogin = () => {
    const navigate = useNavigate();
    //route from kaman
    const {
        mutate: externalLogin,
        isLoading: loadingExternalLogin,
        error,
    } = useMutation(ExternalAccountLogin, {
        onSuccess: (data: ApiResultModel<ICheckOtpResponse>) => {
            if (data.isSuccess) {
                setJwtToken(data.data.jwt!, data.data.refreshToken);
                navigate('/');
            } else {
                // navigate('/externalRoute', { replace: true });
                // window.location.href = '/';
                // setJwtToken('', '');


            }
        },
    });

    return {
        externalLogin,
        loadingExternalLogin,
        error,
    };
};
